'use client'
import { SkeletonItem } from 'components/skeleton-item'

import { useClubhousesTopicsGetDetailsQuery } from '@web/gen/clubhouses'

export function TopicBadge({
  clubhouseName,
  topicSlug,
}: {
  clubhouseName: string
  topicSlug: string
}) {
  const { data: topicName, isPending } = useClubhousesTopicsGetDetailsQuery(
    {
      input: {
        clubhouseSlug: clubhouseName,
        topicSlug: topicSlug || '',
      },
    },
    { select: data => data?.clubhousesTopicsGetDetails?.topic?.topicName },
  )

  return isPending ? (
    <SkeletonItem className="h-[17px] w-32 rounded" />
  ) : (
    <div className="border truncate max-w-40 md:max-w-none border-[#1313151F] tracking-[1.5] text-cf-grey-600 rounded text-10 px-1 bg-cf-grey-50 uppercase font-semibold align-middle h-[17px]">
      {topicName}
    </div>
  )
}
